import React from 'react';
import { Form, Card, Alert } from 'react-bootstrap';
import { PictureOutlined, InfoCircleOutlined } from '@ant-design/icons';

const ImageSearchTab = ({ formData, handleChange }) => (
  <div className="mt-2">
    <Card className="glass-tab-card border-0">
      <Card.Body>
        <div className="d-flex align-items-center mb-1">
          <PictureOutlined style={{ fontSize: '18px', color: '#0071e3', marginRight: '8px' }} />
          <Card.Title className="mb-0" style={{ fontSize: '14px', color: '#1d1d1f' }}>
            Поиск по изображению
          </Card.Title>
        </div>
        <Alert variant="info" className="mb-2 py-1 px-2 border-0" style={{ fontSize: '12px', background: 'rgba(0, 113, 227, 0.08)', borderRadius: '10px' }}>
          <InfoCircleOutlined style={{ marginRight: '4px' }} />
          Укажите прямую ссылку на изображение
        </Alert>
        <Form.Group className="mb-0">
          <Form.Label className="fw-semibold mb-1" style={{ fontSize: '13px', color: '#1d1d1f' }}>
            Ссылка на изображение <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="url"
            name="imageUrl"
            value={formData.imageUrl}
            onChange={handleChange}
            placeholder="https://example.com/image.jpg"
            required={formData.searchType === 'image'}
            className="glass-input"
          />
          <Form.Text className="text-muted mt-0 d-block" style={{ fontSize: '11px' }}>
            PNG, JPG, GIF, WebP по прямой ссылке
          </Form.Text>
        </Form.Group>
      </Card.Body>
    </Card>
  </div>
);

export default ImageSearchTab;

